/* eslint-disable class-methods-use-this */
class InfiniteScroll extends HTMLElement {
  constructor() {
    super();

    this.currentPage = 1;
    this.numberPages = +this.dataset.pages;
    this.loadMoreType = this.dataset.loadType;

    this.collectionGrid = document.querySelector("ul#product-grid");

    this.loadMoreSpinner = this.querySelector(".loading-spinner");
    this.loadMoreButton = this.querySelector("#load_more_button");

    if (this.loadMoreType == "infinite_scroll") {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.loadMoreProducts();
          }
        });
      });

      observer.observe(this.loadMoreSpinner);
    }
    else if (this.loadMoreType == "load_more_button") {
      this.loadMoreButton.addEventListener('click', () => {
        this.loadMoreProducts();
      });
    }
  }

  loadMoreProducts() {
    this.currentPage += 1;

    if (this.currentPage <= this.numberPages) {
      if (this.loadMoreType == "load_more_button") {
        this.setLoading(true);
      }

      const path = window.location.pathname;
      const nextPageUrl = `${path}?page=${this.currentPage}`;

      fetch(nextPageUrl)
        .then((response) => response.text())
        .then((response) => {
          const html = new DOMParser().parseFromString(response, "text/html");
          const grid = html.querySelector("#product-grid");
          const productsToAdd = grid.querySelectorAll('li');

          productsToAdd.forEach((product) => {
            if (product.classList.contains("grid__item") && !product.classList.contains("inline-ad-item")) {
              const listItem = product.cloneNode(true);
              this.collectionGrid.appendChild(listItem);
            }
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          if (this.currentPage != this.numberPages) {
            this.setLoading(false);
          }
          else {
            if (this.loadMoreType == "load_more_button") {
              this.loadMoreButton.style.display = "none";
            }
            else {
              this.loadMoreSpinner.style.visibility = "hidden";
            }
          }
        }
      );
    } else {
      if (this.loadMoreType == "load_more_button") {
        this.loadMoreButton.style.display = "none";
      }
      else {
        this.loadMoreSpinner.style.visibility = "hidden";
      }
    }
  }

  // for load more button
  setLoading(loading) {
    if (!this.loadMoreButton) return;
    const buttonText = this.loadMoreButton.querySelector('.button-text');
    const spinner = this.loadMoreButton.querySelector('.loading-spinner');
    if (loading) {
      buttonText.style.display = "none";
      spinner.style.display = "block";
      this.loadMoreButton.disabled = true;
    }
    else {
      buttonText.style.display = "block";
      spinner.style.display = "none";
      this.loadMoreButton.disabled = false;
    }
  }
}

if (!customElements.get('infinite-scroll')) {
  window.customElements.define('infinite-scroll', InfiniteScroll);
}
